const dev = {
  s3: {
    REGION: "ap-southeast-2",
    BUCKET: "tksl-media-api-dev-storagebucket-vapz35s4xax8",
  },
  apiGateway: {
    REGION: "ap-southeast-2",
    URL: "https://omtm8y3xvk.execute-api.ap-southeast-2.amazonaws.com/dev",
  },
  cognito: {
    REGION: "ap-southeast-2",
    USER_POOL_ID: "ap-southeast-2_cjHRuvN8r",
    APP_CLIENT_ID: "4qfbv58p00rs43oq6k9gkunh16",
    IDENTITY_POOL_ID: "ap-southeast-2:8c30749d-f756-4bf4-961e-29d09e3757ca",
  },
};

const prod = {
  s3: {
    REGION: "ap-southeast-2",
    BUCKET: "tksl-media-api-prod-storagebucket-11xa54ovocmk6",
  },
  apiGateway: {
    REGION: "ap-southeast-2",
    URL: "https://026wjzf933.execute-api.ap-southeast-2.amazonaws.com/prod",
  },
  cognito: {
    REGION: "ap-southeast-2",
    USER_POOL_ID: "ap-southeast-2_3H0QImyzp",
    APP_CLIENT_ID: "5b4ujk9v820on6b1gn66gak15t",
    IDENTITY_POOL_ID: "ap-southeast-2:885f62e3-ec52-4bc1-ade2-7aa809003377",
  },
};

// Default to dev if not set
const config = process.env.REACT_APP_STAGE === "prod" ? prod : dev;

export default {
  SITE_URL: "https://tkslmedia.netlify.app",
  ...config,
};
